import { FormHelperText, IconButton, Input, InputAdornment } from "@mui/material";
import { styled } from "styled-components";

export const TitleInput = styled(Input)({
  flexGrow: 1,
  color: "#fff",
  fontSize: "14px",
  marginRight: "1rem",
  "@media (max-width:400px)": {
    fontSize: "0.875rem",
    marginRight: "0.5rem",
  },
  "&.MuiInput-underline": {
    "&:before": {
      borderBottom: "0px !important",
    },
    "&:hover:not($disabled):not($focused):not($error):before": {
      borderBottom: "0px !important",
    },
    "&:after": {
      borderBottom: "1px solid #71B6BC !important",
    },
  },
  "&.MuiInput-disabled": {},
  "&.MuiInput-focused": {},
  "&.MuiInput-error": {},
});

export const TitleInputAdornment = styled(InputAdornment)<{ $editingTitle: boolean }>(({ $editingTitle }) => ({
  backgroundColor: "transparent",
  visibility: $editingTitle ? "visible" : "hidden",
}));

export const ErrorHelperText = styled(FormHelperText)({
  "&.MuiFormHelperText-root": {
    top: "7px",
    position: "absolute",
    right: "-35px",
  },
});

export const SettingsIconButton = styled(IconButton)({
  "&.MuiIconButton-root": {
    color: "#fff",
  },
  "&.MuiIconButton-root.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.25) !important",
  },
});
